
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useQuestItemEdit } from '@/modules/quest/item/model/edit';
import { QuestItemGameType } from '@/modules/quest/item/model/mixins';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';

export default defineComponent({
    name: ROUTE_NAME_QUEST.ITEM.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, questTypeOptions, actions } = useQuestItemEdit();

        return { v$, model, actions, questTypeOptions, QuestItemGameType };
    }
});
